// extracted by mini-css-extract-plugin
export default {"files":"reportsPage_files__CE3xX","file":"reportsPage_file__o3vmn","file_name":"reportsPage_file_name__EhSaD","file_format":"reportsPage_file_format__lYwhg"};